const tracker = (...parameters) => {
  if (typeof window !== 'undefined' && window.gptr) {
    window.gptr(...parameters);
  }
};

export default tracker;
